// extracted by mini-css-extract-plugin
export default {"container":"style_container__CfUYo","txtCont":"style_txtCont__bmyiD","icon":"style_icon__40WBl"};